import "../css/styles.css";
import { getMarkdownContentandCreateChatbot } from "./processMarkdown/chatbotData";

getMarkdownContentandCreateChatbot();
